module.exports = __webpack_public_path__ + "static/img/cont3620.bbb183a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3620.jpg
// module id = x72n
// module chunks = 0